import {createContext} from 'react'

const PadecimientoActualContext = createContext()

export default PadecimientoActualContext